import { motion } from "framer-motion";

export function ProgressBar({ progress }: { progress: number }) {
  return (
    <div className="relative h-2 w-full rounded-3xl bg-gray-200">
      <motion.div
        className="absolute bottom-0 left-0 top-0 rounded-3xl bg-primary"
        initial={{ width: `${progress}%` }}
        animate={{ width: `${progress}%` }}
        transition={{
          duration: 0.8,
          ease: [0.4, 0.0, 0.2, 1],
        }}
      />
    </div>
  );
}
